import Select from "react-select";
import DropDownStyles from "./dropdownStyles";
import { useFishTypes, normalizeFishTypesData } from "../../hooks/queries/useFishTypes";

const FishSpeciesDropDownSelection = ({
  onChange,
  selectedValue,
  allowMultiple,
}) => {
  const { data } = useFishTypes({ search: "" });
  const fishSpeciesData = normalizeFishTypesData(data);

  const FishSpeciesOptions = fishSpeciesData.map((species) => ({
    value: species.id,
    label: species.Name,
  }));

  return (
    <Select
      value={
        allowMultiple
          ? FishSpeciesOptions.filter((option) => selectedValue?.includes(option.value))
          : FishSpeciesOptions.find((option) => option.value === selectedValue)
      }
      onChange={(selectedOptions) => {
        const values = allowMultiple
          ? selectedOptions ? selectedOptions.map((opt) => opt.value) : []
          : selectedOptions ? selectedOptions.value : null;
        onChange(values);
      }}
      options={FishSpeciesOptions}
      styles={DropDownStyles}
      isMulti={allowMultiple}
      placeholder="Select Fish Species"
      isClearable={true}
    />
  );
};

export default FishSpeciesDropDownSelection;
